import { application } from '@core/controllers/app';

application.register('plugins-hellgate--payments',
  require('./plugins_hellgate/payments_controller').default);
